module.exports = __webpack_public_path__ + "img/danger.7ed79b8f.svg";